/* Client-side item icon mapping + XP curve helpers (mirror backend). */

export const ITEM_ICON = {
  // ores/bars
  copper_ore: "🟤", tin_ore: "⚪", iron_ore: "⬛", coal: "◼",
  bronze_bar: "🟠", iron_bar: "⬜", steel_bar: "🔷",
  // logs
  logs: "🪵", oak_logs: "🪵", willow_logs: "🪵",
  // fish
  raw_shrimp: "🦐", shrimp: "🍤", burnt_shrimp: "💀",
  raw_trout: "🐟", trout: "🍽", burnt_trout: "💀",
  raw_salmon: "🐠", salmon: "🍽", burnt_salmon: "💀",
  // gear
  bronze_sword: "🗡", bronze_scimitar: "🗡", iron_sword: "⚔",
  iron_scimitar: "⚔", steel_scimitar: "⚔",
  // fletching
  shortbow: "🏹", oak_shortbow: "🏹", willow_shortbow: "🏹",
  arrow_shafts: "➰",
  // crafting
  cowhide: "🟫", leather: "🟫",
  leather_gloves: "🧤", leather_boots: "🥾", leather_body: "🎽",
  leather_chaps: "👖", leather_cape: "🧣",
  uncut_sapphire: "🔷", sapphire: "🔵", uncut_emerald: "💚", emerald: "🟢",
  // jewellery
  amulet_of_power: "📿", sapphire_amulet: "📿",
  ring_of_might: "💍", ring_of_guard: "💍",
  // arrows
  bronze_arrows: "🏹", iron_arrows: "🏹",
  // metal armour
  bronze_helm: "🪖", iron_helm: "🪖", steel_helm: "🪖",
  bronze_platebody: "🥋", iron_platebody: "🥋", steel_platebody: "🥋",
  bronze_platelegs: "👖", iron_platelegs: "👖", steel_platelegs: "👖",
  bronze_shield: "🛡", iron_shield: "🛡", steel_shield: "🛡",
  // farming
  potato: "🥔", onion: "🧅", cabbage: "🥬",
  // herblore
  grimy_guam: "🌿", clean_guam: "🌱",
  grimy_tarromin: "🌿", clean_tarromin: "🌱",
  eye_of_newt: "👁", limpwurt_root: "🪴",
  attack_potion: "🧪", strength_potion: "🧪",
  // runecrafting
  rune_essence: "⚪",
  air_rune: "💨", water_rune: "💧", earth_rune: "🌍", fire_rune: "🔥",
  // hunter
  raw_bird_meat: "🍗", chinchompa: "🐿", kebbit_fur: "🟫",
  // misc
  bones: "🦴", big_bones: "🦴", feathers: "🪶", coins: "🪙",
};

// Skills that we render as painted asset icons (from /generated/*)
export const SKILL_ASSET = new Set([
  "woodcutting", "mining", "fishing", "cooking",
  "firemaking", "smithing", "attack", "strength",
  "defence", "hitpoints",
  "fletching", "crafting", "herblore", "runecrafting",
  "farming", "hunter", "agility", "thieving", "slayer",
  "construction",
]);

export function skillIcon(skill) {
  if (SKILL_ASSET.has(skill)) return `/generated/skill_${skill}.png`;
  return null;
}

export function monsterIcon(monsterId) {
  const known = ["chicken", "goblin", "skeleton"];
  if (known.includes(monsterId)) return `/generated/monster_${monsterId}.png`;
  return null;
}

export function pctInLevel(sd) {
  if (!sd) return 0;
  if (!sd.xp_needed) return 100;
  return Math.min(100, Math.round((sd.xp_into / sd.xp_needed) * 100));
}

export const SKILL_LABEL = {
  woodcutting: "Woodcutting", mining: "Mining", fishing: "Fishing",
  farming: "Farming", hunter: "Hunter",
  smithing: "Smithing", fletching: "Fletching", cooking: "Cooking",
  crafting: "Crafting", herblore: "Herblore", runecrafting: "Runecrafting",
  construction: "Construction",
  firemaking: "Firemaking", agility: "Agility", thieving: "Thieving", slayer: "Slayer",
  attack: "Attack", strength: "Strength", defence: "Defence",
  ranged: "Ranged", magic: "Magic", prayer: "Prayer", hitpoints: "Hitpoints",
};

export function itemName(id, contentItems) {
  return contentItems?.[id]?.name || id.replace(/_/g, " ");
}
